/**
 * 『マーク指示』画面の受渡用VO
 *
 * @export KYMW1409InputModel
 * @class KYMW1409InputModel
 */
export class KYMW1409InputModel {

  /**
   * 受注コード
   */
  public orderCode = String('');

  /**
   * 生協コード
   */
  public coopCode = String('');

  /**
   * Ｐコードリスト
   */
  public pCodeList: Array<any> = new Array<any>();

  /**
   * 注文商品区分
   */
  public orderGoodsFlg = String('');
  /**
   * 受付開始受注コード
   */
  public receiptSOrderCode = String('');
  /**
   * 注文コード
   */
  public orderNum6Digits = String('');
  /**
   * アイテムコード
   */
  public itemCode = String('');

  // いつでも注文の商品情報
  public NvalInputList: Array<any> = new Array<any>();

  /**
   * 注文商品区分（コマ割画面遷移用）
   */
  public orderGoodsFlgKoma: Array<any> = new Array<any>();

  /**
   * 編集モード
   * 0:編集可、1:編集不可(ロック時)
   */
  public editMode = String('');

}
